import React from "react";
import "./FestivalTrip.css";
import RioCarnivalCelebration from "../../assets/RioCarnivalCelebration.png";
import DiwaliFestivalTour from "../../assets/DiwaliFestivalTour.png";
import OktoberfestMunichExperience from "../../assets/OktoberfestMunichExperience.png";
import HoliColorFestivalJourney from "../../assets/HoliColorFestivalJourney.png";
import CherryBlossomFestivalJapan from "../../assets/CherryBlossomFestivalJapan.png";
import LaTomatinaFestivalTrip from "../../assets/LaTomatinaFestivalTrip.png";
import { useNavigate } from "react-router-dom";
const festivalTrips = [
  {
    title: "Rio Carnival Celebration",
    image: RioCarnivalCelebration,
    description:
      "Experience the vibrant energy of Rio Carnival with dazzling parades, colorful costumes, lively samba music, and exciting street celebrations. Enjoy cultural performances, festive atmosphere, and unforgettable moments during this world famous festival adventure.",
    link: "/tour-package-data",
  },
  {
    title: "Diwali Festival Tour",
    image: DiwaliFestivalTour,
    description:
      "Celebrate the Festival of Lights with sparkling decorations, traditional rituals, delicious sweets, and joyful gatherings. Explore illuminated streets, cultural events, and vibrant markets while experiencing the warmth and happiness of Diwali celebrations.",
    link: "/tour-package-data",
  },
  {
    title: "Oktoberfest Munich Experience",
    image: OktoberfestMunichExperience,
    description:
      "Join the lively Oktoberfest celebration in Munich filled with traditional music, festive tents, cultural performances, and delicious Bavarian cuisine. Enjoy vibrant atmosphere, joyful crowds, and authentic traditions during this exciting festival trip.",
    link: "/tour-package-data",
  },
  {
    title: "Holi Color Festival Journey",
    image: HoliColorFestivalJourney,
    description:
      "Immerse yourself in the colorful celebrations of Holi with joyful gatherings, vibrant powders, music, and festive dances. Experience cultural traditions, delicious treats, and unforgettable moments during this lively spring festival adventure.",
    link: "/tour-package-data",
  },
  {
    title: "Cherry Blossom Festival Japan",
    image: CherryBlossomFestivalJapan,
    description:
      "Witness the beauty of cherry blossoms in full bloom across scenic parks and streets in Japan. Enjoy cultural performances, traditional food stalls, peaceful walks, and breathtaking floral landscapes during this enchanting seasonal festival.",
    link: "/tour-package-data",
  },
  {
    title: "La Tomatina Festival Trip",
    image: LaTomatinaFestivalTrip,
    description:
      "Participate in the thrilling La Tomatina festival filled with fun, laughter, and energetic crowds. Experience unique traditions, festive spirit, lively music, and unforgettable memories during this exciting cultural celebration.",
    link: "/tour-package-data",
  },
];

const FestivalTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="festival-container">
      <h2 className="festival-title">Festival Trip Packages</h2>

      <div className="festival-grid">
        {festivalTrips.map((trip, index) => (
          <div
            className="festival-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="festival-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FestivalTrip;
